
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/rules/g/[game]",
      function () {
        return require("private-next-pages/rules/g/[game].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/rules/g/[game]"])
      });
    }
  